/**
 * countdown-timer.js
 * Drives all .countdown-banner__timer elements on the page, using the
 * shared window.theme.CountdownEngine (assets/countdown-engine.js,
 * loaded first) for the actual parsing/ticking/visibility-pausing —
 * see that file for the engine itself. This file only finds instances
 * on the page and manages their lifecycle (including Shopify Theme
 * Editor section load/unload, so re-editing a section doesn't leave
 * duplicate intervals running).
 */
(function () {
  'use strict';

  var engines = [];

  function initTimer(el) {
    var engine = new window.theme.CountdownEngine(el);
    engine.start();
    engines.push(engine);
  }

  function boot() {
    var els = document.querySelectorAll('.countdown-banner__timer[data-year]');
    els.forEach(initTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor: re-init when section reloads
  document.addEventListener('shopify:section:load', function (e) {
    var timerEl = e.target.querySelector('.countdown-banner__timer[data-year]');
    if (timerEl) initTimer(timerEl);
  });

  // Shopify Theme Editor: clean up on section unload to prevent duplicate intervals
  document.addEventListener('shopify:section:unload', function () {
    engines.forEach(function (engine) { engine.destroy(); });
    engines = [];
  });

})();